<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <h4 class="font-weight-semibold mb-3 mb-md-4">Are you sure you want to cancel this booking?</h4>
    <div class="d-flex align-items-center column-gap-3 mt-3 mt-md-4 mt-lg-5">
        <button class="btn btn-clear w-50" type="button" (click)="modal.dismiss()">Cancel</button>
        <button class="btn btn-primary w-50" type="button" (click)="cancelBooking()">Cancel Booking</button>
    </div>
</div>